import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Statistic, Typography, Progress } from 'antd';
import {
  CheckCircleOutlined,
  CalendarOutlined,
  TrophyOutlined
} from '@ant-design/icons';
import axios from '../../utils/request';

const { Title } = Typography;

interface Statistics {
  totalCoupons: number;
  usedCoupons: number;
}

const SalesStatistics: React.FC = () => {
  const [stats, setStats] = useState<Statistics>({
    totalCoupons: 0,
    usedCoupons: 0
  });
  const [loading, setLoading] = useState(false);

  const fetchStatistics = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/coupons/statistics');
      setStats(response.data);
    } catch (error: any) {
      console.error('获取统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStatistics();
  }, []);


  const completionRate = stats.totalCoupons > 0
    ? Math.round((stats.usedCoupons / stats.totalCoupons) * 100)
    : 0;

  return (
    <div style={{ padding: '24px' }}>
      <Title level={3}>我的核销统计</Title>
      
      <Row gutter={[16, 16]} style={{ marginBottom: '24px' }}>
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="总核销数量"
              value={stats.usedCoupons}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a' }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="总分配优惠券"
              value={stats.totalCoupons}
              prefix={<CalendarOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>
        
        <Col xs={24} sm={12} lg={6}>
          <Card loading={loading}>
            <Statistic
              title="完成率"
              value={completionRate}
              suffix="%"
              prefix={<TrophyOutlined />}
              valueStyle={{ color: '#faad14' }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col xs={24} lg={12}>
          <Card title="核销完成度" loading={loading}>
            <div style={{ textAlign: 'center' }}>
              <Progress
                type="circle"
                percent={completionRate}
                format={percent => `${percent}%`}
                strokeColor={{
                  '0%': '#108ee9',
                  '100%': '#87d068',
                }}
                size={160}
              />
              <div style={{ marginTop: '16px', fontSize: '16px', color: '#666' }}>
                已完成 {stats.usedCoupons} 张优惠券核销
              </div>
            </div>
          </Card>
        </Col>
        
        <Col xs={24} lg={12}>
          <Card title="核销统计" loading={loading}>
            <div style={{ 
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              padding: '24px',
              borderRadius: '8px',
              textAlign: 'center'
            }}>
              <p style={{ margin: 0, fontSize: '16px' }}>
                您已成功核销 {stats.usedCoupons} 张优惠券，为客户提供了优质的服务体验
              </p>
            </div>
          </Card>
        </Col>
      </Row>

    </div>
  );
};

export default SalesStatistics;